import { ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  children?: ReactNode;
  icon?: IconProp;
  picture?: string;
  picturePosition?: string;
}

const PathStepTilePicture = ({ children, icon }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="picture">
      {children || (
        <div className="inner">
          <div className="icon">
            <Icon icon={icon} />
          </div>
        </div>
      )}

      <style jsx>{`
        .picture {
          background-color: ${theme.lightGrey};
          height: 150px;
          position: relative;
          width: 100%;
        }
        .inner {
          align-items: center;
          display: flex;
          justify-content: center;
          height: 100%;
        }
        .icon {
          align-items: center;
          background-color: white;
          border-radius: 60px;
          color: ${theme.textColorLight};
          display: inline-flex;
          font-size: 2.6rem;
          justify-content: center;
          height: 60px;
          width: 60px;
        }
      `}</style>
    </div>
  );
};

export default PathStepTilePicture;
